import Vue from 'vue'
import VueRouter from 'vue-router'

import Area from './area'
import Classification from './classification'
import Cbo from './cbo'
import Cid from './cid'
import City from './city'
import CompanionType from './companion_type'
import Company from './company'
import DispatchType from './dispatch_type'
import DispatchReason from './dispatch_reason'
import Establishment from './establishment'
import EstablishmentType from './establishment_type'
import Involved from './involved'
import Profile from './profile'
import Professional from './professional'
import ProfessionalType from './professional_type'
import RejectionType from './rejection_type'
import Discipline from './discipline'
import Equipment from './equipment'
import Retention from './retention'
import Team from './team'
import TeamBoarding from './team_boarding'
import TeamType from './team_type'
import Occurrence from './occurrence'
import Regulacao from './regulacao'
import Despacho from './despacho'
import User from './user'
import Uf from './uf'
import Vehicle from './vehicle'
import VehicleType from './vehicle_type'
import Node from './node'
import Role from './role'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    Area,
    Classification,
    Cbo,
    Cid,
    City,
    CompanionType,
    Company,
    DispatchType,
    DispatchReason,
    Establishment,
    EstablishmentType,
    Involved,
    Profile,
    Professional,
    ProfessionalType,
    RejectionType,
    Discipline,
    Equipment,
    Retention,
    Team,
    TeamBoarding,
    TeamType,
    Occurrence,
    Regulacao,
    Despacho,
    Uf,
    User,
    Vehicle,
    VehicleType,
    Node,
    Role,
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/select-node',
      name: 'select-node',
      component: () => import('@/views/NodeSelector.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const access_nivel = localStorage.getItem('access_nivel');
  const authenticated = localStorage.getItem('token');
  let to_splited = to.path.toString().split('/')
  to_splited = to_splited.filter(part => part !== '')

  if (
    !authenticated &&
    (
      !(['/login', '/select-node'].includes(to.path.toString())) &&
      !(['public'].includes(to_splited[0]))
    )
  ) {
    next('/login');

    return true;
  }

  if (to.meta.access_nivel) {
    if (!to.meta.access_nivel.includes(access_nivel)) {
      next('/');
      return;
    }
  }

  next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
